/**
 * O recorte de clientes do Fee Fixo como formulário que a IA sabe preencher
 * ([T019] / US-5 da spec-010; nasceu dentro do `preencher.js` no [T015]).
 *
 * ★ Por que MORA AQUI, e não no `preencher.js`
 *
 * Achado I-5 da review da spec-001: a tool genérica importava
 * `@modules/fee-fixo/utils/filtro-tipado`. Um formulário por módulo somaria um
 * import de módulo por formulário no mesmo arquivo — o oposto do que o registry
 * de cartões faz desde o [T017], em que o MÓDULO se registra e o agregado só
 * consulta. Aqui é o mesmo princípio, aplicado ao `preencher`: o dono do
 * formulário declara o contrato dele e chama `registrarFormulario` no boot
 * (`modules/fee-fixo/index.js`), ao lado do `registrar(registryFeeFixo)`.
 *
 * O canal continua sendo a store: a tela do recorte já está montada e lê
 * `feeFixoIa/filtroSugerido` (`view-fee-fixo-clientes.vue` e o card do guia).
 * O validador é o DA PRÓPRIA TELA (`utils/filtro-tipado.js`, com allow-list de
 * campos e operadores) — escrever aqui uma segunda régua de "filtro válido"
 * seria criar a divergência que o [G-Q2] já custou uma vez.
 */
import { validarFiltro } from '@modules/fee-fixo/utils/filtro-tipado'
import {
  registrarFormulario,
  formularioRegistrado,
  CANAL_STORE,
} from '@modules/aawz-intelligence-v2/ui-registry/tools-de-front/preencher'

export const FORMULARIO_FILTROS_CLIENTES = 'fee-fixo/filtros-clientes'

export const formularioFiltrosClientes = {
  nome: FORMULARIO_FILTROS_CLIENTES,
  canal: CANAL_STORE,
  namespace: 'feeFixoIa',
  action: 'setFiltroSugerido',
  /**
   * `campos` = `{filtros: [{campo, operador, valor}]}`. O veredito do validador
   * da tela — `{valido, filtros, erros}` — é o próprio payload do dispatch,
   * exatamente o mesmo shape que a tool `sugerir_filtro_clientes` já grava
   * neste canal.
   */
  validar: (campos) => validarFiltro({ filtros: (campos || {}).filtros }),
  montarPayload: (veredito) => veredito,
  camposAplicados: (veredito) =>
    (veredito.filtros || []).map((f) => f && f.campo).filter(Boolean),
}

/**
 * Liga o formulário ao `preencher`. Chamado no boot do módulo. Idempotente
 * pelo mesmo motivo do `registrarPlataforma`: `registrarFormulario` ESTOURA em
 * nome repetido (por desenho), então registrar duas vezes precisa ser um no-op
 * explícito — e não uma exceção no boot.
 *
 * A guarda consulta o REGISTRO, não uma flag da função: assim ela continua
 * verdadeira depois de um `limparFormularios()` (o que o teste faz para montar
 * um cenário controlado).
 */
export function registrarFormularioFiltrosClientes() {
  if (formularioRegistrado(FORMULARIO_FILTROS_CLIENTES)) return
  registrarFormulario(formularioFiltrosClientes)
}

export default formularioFiltrosClientes
